<template>
  <div
    v-if="request.requestType === 'PQT'"
    class="my-3"
    style="line-height: 1.5"
  >
    <strong class="text-dark">{{ $t('pqtExtrasView.ilkinZruriRtlr') }}</strong>
    <div>
      <span>{{ $t('pqtExtrasView.valyuta') }} </span>
      <span class="text-dark">{{ requestExtras.currency }}</span>
      <span
        v-if="requestExtras.currencyRequired==='true'"
        class="badge badge-danger"
      >{{ $t('pqtExtrasView.mtlq') }}</span>
      <span
        v-else
        class="badge badge-light"
      >{{ $t('pqtExtrasView.arzuOlunan') }}</span>
    </div>
    <!--    <div>-->
    <!--      <span>{{ $t('offerExtrasView.dniSulu') }} </span>-->
    <!--      <span-->
    <!--        v-if="requestExtras.paymentRequired==='true'"-->
    <!--        class="badge badge-danger"-->
    <!--      >Bəli</span>-->
    <!--      <span-->
    <!--        v-else-->
    <!--        class="badge badge-light"-->
    <!--      >{{ $t('pqtExtrasView.arzuOlunan') }}</span>-->
    <!--    </div>-->
    <div>
      <span>Yalnız təsdiqlənmiş tədarükçülər: </span>
      <span
        v-if="request.onlyVendors"
        class=" badge badge-danger"
      >
        Bəli
      </span>
      <span
        v-else
        class="badge badge-light"
      >
        Xeyr
      </span>
    </div>
    <div>
      <span>{{ $t('offerExtrasView.atdrlma') }} </span>
      <span
        v-if="requestExtras.deliveryNeeded === 'true'"
        class=" badge badge-danger"
      >
        Bəli
      </span>
      <span
        v-else
        class="badge badge-light"
      >{{ $t('pqtExtrasView.ehtiyacYoxdur') }}</span>
    </div>
    <div>
      <span>{{ $t('offerExtrasView.deliveryTimeNeeded') }} </span>
      <span
        v-if="requestExtras.deliveryTimeNeeded === 'true'"
        class=" badge badge-danger"
      >
        Bəli
      </span>
      <span
        v-else
        class="badge badge-light"
      >{{ $t('pqtExtrasView.ehtiyacYoxdur') }}</span>
    </div>

    <div>
      <span>{{ $t('offerExtrasView.paymentRequired') }} </span>
      <span
        v-if="requestExtras.paymentRequired === 'true'"
        class=" badge badge-danger"
      >
        Bəli
      </span>
      <span
        v-else
        class="text-dark"
      >{{ $t('pqtExtrasView.ehtiyacYoxdur') }}</span>
    </div>
    <div>
      <span>{{ $t('offerExtrasView.guarantyTime') }} </span>
      <span
        v-if="requestExtras.guarantyTime === 'true'"
        class=" badge badge-danger"
      >
        Bəli
      </span>
      <span
        v-else
        class="badge badge-light"
      >{{ $t('pqtExtrasView.ehtiyacYoxdur') }}</span>
    </div>
    <div>
      <span>{{ $t('offerExtrasView.producerCountry') }} </span>
      <span
        v-if="requestExtras.countryRequired === 'true'"
        class=" badge badge-danger"
      >
        Bəli
      </span>
      <span
        v-else
        class="badge badge-light"
      >{{ $t('pqtExtrasView.ehtiyacYoxdur') }}</span>
    </div>
    <div>
      <span>Alternativ məhsul təklif edilsinmi? : </span>
      <span
        v-if="requestExtras.alternativeRequired === 'true'"
        class=" badge badge-danger"
      >
        Bəli
      </span>
      <span
        v-else
        class="text-dark"
      >{{ $t('pqtExtrasView.ehtiyacYoxdur') }}</span>
    </div>
    <div>
      <span>Təkliflər öncədən görünsünmü? : </span>
      <span
        v-if="requestExtras.showBefore === 'true'"
        class=" badge badge-danger"
      >
        Bəli
      </span>
      <span
        v-else
        class="text-dark"
      >{{ $t('pqtExtrasView.ehtiyacYoxdur') }}</span>
    </div>


    <div v-if="request.autoWinner">
      <span>{{ $t('pqtExtrasView.method') }} </span>
      <span
        class="badge badge-light"
      >{{
        request.autoWinner === 1 ? $t('newAUCRequest.manual') : $t('newAUCRequest.automatic')
      }}</span>
    </div>
    <div v-if="requestExtras.initialRequirementNotes">
      <span>{{ $t('pqtExtrasView.qeyd') }} </span>
      <span class="text-dark">{{ requestExtras.initialRequirementNotes }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PQTExtrasView',
  props: {
    request: {},
    requestExtras: {}
  }
}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}
</style>
